export default __webpack_public_path__ + "static/media/2022-AMcover.a04d09ef.png";